import { render, staticRenderFns } from "./ContactsList2.vue?vue&type=template&id=43d3cd5f&scoped=true&"
import script from "./ContactsList2.vue?vue&type=script&lang=ts&"
export * from "./ContactsList2.vue?vue&type=script&lang=ts&"
import style0 from "./ContactsList2.vue?vue&type=style&index=0&id=43d3cd5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d3cd5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VImg,VList,VToolbar})
